export enum PublicationType {
    Video = 1,
    Screen
}
